import { observer } from "mobx-react";
import { Box } from "@mui/material";
import ContentBlock from "../components/ContentBlock";
import { useEffect, useState } from "react";
import LineChart from "../components/charts/LineChart";
import EQ5D5LDayList from "../components/lists/EQ_5D-5L_DayList";
import ReadMoreInfo from "../components/ReadMoreInfo";
import GenericForm from "../components/forms/GenericForm";
import { FieldGroupId } from "../lib/enums";
import { useStoreContext } from "..";
import {
  FormGetField,
  FormSaveRequest,
  FormSaveRequestSchema,
  FormsGetResponse,
} from "../models/Form";

const EQ5D5L = observer(() => {
  const [formDatas, setFormDatas] = useState<FormsGetResponse | null>(null);
  const [listFormDatas, setListFormDatas] = useState<FormsGetResponse | null>(
    null
  );
  const { formStore, fieldStore } = useStoreContext();
  useEffect(() => {
    const fetchFields = async () => {
      if (!formStore.forms) {
        await formStore.getForms();
      }
      if (!fieldStore.fields) {
        await fieldStore.getFields();
      }

      const forms = await formStore.getFormsByFormId(
        FieldGroupId.EQ5D5L_FIELD_GROUP_ID
      );
      const fields = fieldStore.fields;
      if (forms && fields) {
        setFormDatas(forms);
        const populatedForms = forms.map((form) => {
          const formValues = form.values as unknown as FormGetField[];
          const populatedValues = formValues.map((formValue) => {
            const field = fields.find((f) => f.alias === formValue.fieldAlias);
            const optionName = field?.fieldOptions?.find(
              (option) => option.id == formValue.value
            )?.name;
            if (!optionName) {
              return formValue;
            }
            return { ...formValue, value: optionName };
          });
          return { ...form, values: populatedValues };
        });
        if (populatedForms) {
          setListFormDatas(populatedForms);
        }
      }
    };
    fetchFields();
  }, [formStore.forms]);

  const onSave = (data: any) => {
    formStore.saveForm(data as FormSaveRequest);
  };

  return (
    <Box className="page-container">
      <Box sx={{ marginBottom: 2 }}>
        <ReadMoreInfo
          text="Här finner du enkätfrågor som berör din livskvalitet. Dessa är standardiserade frågeformulär som mäter självskattat hälsotillstånd. När du svarar på frågorna så tänkt på hela din hälsa, inte bara immunbristen eller den ökade infektionsbenägenheten."
          moreText="Först i EQ5D-L formuläret finns en skala där du genom att dra ”reglaget” upp och ner väljer en siffra som motsvarar ditt aktuella hälsotillstånd (100 = bästa tänkbara tillstånd, 0 = sämsta tänkbara tillstånd). Det är det värdet som syns när du loggar in på Hälsodagboken. I diagrammet kan du se ditt hälsotillstånd över tid."
        />
      </Box>
      <ContentBlock title="Registrera: EQ-5D-5L" icon="edit" bottomMargin>
        <GenericForm
          currentData={undefined as any}
          zodDataSchema={FormSaveRequestSchema}
          formId={FieldGroupId.EQ5D5L_FIELD_GROUP_ID}
          onSave={onSave}
        />
      </ContentBlock>
      <ContentBlock
        title="Självuppskattat hälsotillstånd"
        icon="graph"
        bottomMargin
      >
        {formDatas && (
          <LineChart
            items={formDatas as any}
            xAxisKey="D_EQ5D_Datum"
            valueKey="D_EQ5D_6_VAS"
          />
        )}
      </ContentBlock>
      {listFormDatas && (
        <ContentBlock title="EQ-5D-5L" icon="list">
          <EQ5D5LDayList items={listFormDatas as any} />
        </ContentBlock>
      )}
    </Box>
  );
});

export default EQ5D5L;
